import { WeightUnit } from "@redotech/crdb-enums/product/weight-unit";
import { RedoListItem } from "@redotech/redo-web/arbiter-components/list/redo-list";

export const weightOptions: RedoListItem<WeightUnit>[] = Object.entries(
  WeightUnit,
)
  .filter(([name, value]) => name !== "TONNES")
  .map(([name, value]) => ({
    id: value,
    type: "text" as const,
    text: value,
    value,
  }));
